import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule, MatLegacyDialogRef,
} from '@angular/material/legacy-dialog';
import { appMatDialogDefaultConfig } from '../../../../helper/helper';
import { FormControl, FormsModule } from '@angular/forms';
import {
    ArlLongInformationDialogComponentDialogData
} from '../../../../dave-reports/components/arl-long-information-dialog/arl-long-information-dialog.component';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { TextFieldModule } from '@angular/cdk/text-field';

export interface NoteDialogComponentDialogData {
    text: string;
}
export type NoteDialogReturnData = {
    text: string;
}

@Component({
  selector: 'app-note-dialog',
  standalone: true,
    imports: [CommonModule, AppButtonModule, FontAwesomeModule, FormsModule, MatLegacyDialogModule, MatLegacyFormFieldModule, MatLegacyInputModule, MatLegacySlideToggleModule, TextFieldModule],
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss']
})
export class NoteDialogComponent {
    static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        disableClose: true,
        minWidth: '30rem',
    };

    protected text = '';

    constructor(@Inject(MAT_DIALOG_DATA) dialogData: NoteDialogComponentDialogData,private dialogRef: MatLegacyDialogRef<NoteDialogComponent, NoteDialogReturnData>) {
        this.text = dialogData.text;
    }

    submitOnShiftEnter(event: KeyboardEvent, ) {
        console.log(event);
        if (event.key === 'Enter' && event.shiftKey) {
            console.log('shift enter');
            event.preventDefault();
            this.submit();
        }
    }

    submit() {
        const result: NoteDialogReturnData = {
            text: this.text
        };

        console.log("Dialog OUTPUT:", result);

        this.dialogRef.close(result);
    }
}
